module.exports = __webpack_public_path__ + "img/56.f10baf30.png";